export const readAssetFromExtension = async (path: string, basePath?: string) => {
  const url = basePath ? `${basePath}${path}` : chrome.runtime.getURL(path);
  const file = await fetch(url)
    .then(async (res) => res.text())
    .catch(() => null);
  return file;
};
